import { forwardRef, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Turnstile, type TurnstileInstance } from '@marsidev/react-turnstile';
import { Field, Input, FieldError, Button } from '@/ui';
import * as s from '@/pages/LoginPage.css';

export const EmailStepForm = forwardRef<
  TurnstileInstance,
  {
    email: string;
    onEmailChange: (value: string) => void;
    onSubmit: (e: FormEvent) => void;
    submitting: boolean;
    error: string | null;
    turnstileEnabled: boolean;
    turnstileSiteKey: string | null;
    turnstileReady: boolean;
    onTurnstileToken: (token: string) => void;
  }
>(function EmailStepForm(
  { email, onEmailChange, onSubmit, submitting, error,
    turnstileEnabled, turnstileSiteKey, turnstileReady, onTurnstileToken },
  turnstileRef,
) {
  const { t } = useTranslation();
  const busy = submitting || !turnstileReady;
  return (
    <form id="login-email-form" onSubmit={onSubmit}>
      <Field>
        <label className={s.emailLabel} htmlFor="login-email">{t('login.emailLabel')}</label>
        <Input
          id="login-email"
          type="email"
          name="username"
          autoComplete="username"
          required
          placeholder={t('login.emailPlaceholder')}
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
        />
      </Field>

      {turnstileEnabled && turnstileSiteKey && (
        <Turnstile
          ref={turnstileRef}
          siteKey={turnstileSiteKey}
          options={{ size: 'invisible' }}
          onSuccess={(token) => onTurnstileToken(token)}
          onExpire={() => onTurnstileToken('')}
          onError={() => onTurnstileToken('')}
        />
      )}

      {error && <FieldError>{error}</FieldError>}

      <div className={s.sendCodeButton}>
        <Button id="login-email-submit" type="submit" variant="primary" block
                disabled={submitting || !email || !turnstileReady}>
          {busy ? (submitting ? t('login.sending') : t('login.verifyingHuman')) : t('login.sendCode')}
        </Button>
      </div>
    </form>
  );
});
